import {
	IconSquareArrowUpRightOutline18 as ExternalLink,
	IconMonitorOutline18 as Monitor,
} from "nucleo-ui-outline-18"

import { cn } from "@productlane/lib/src/browser"

const SEPARATOR = " · "
const MAX_URL_LENGTH = 50

function isUrl(value: string) {
	return /^https?:\/\//i.test(value)
}

function truncateUrl(value: string) {
	return value.length > MAX_URL_LENGTH
		? `${value.slice(0, MAX_URL_LENGTH - 1)}…`
		: value
}

export function parseDeviceInfoText(raw: string): {
	url: string | null
	meta: string
	text: string
} | null {
	const text = raw.replace(/<[^>]*>/g, "").trim()
	if (!text) return null

	const parts = text.split(SEPARATOR)
	const urlIndex = parts.findIndex(isUrl)
	const url = urlIndex >= 0 ? (parts[urlIndex] ?? null) : null
	const meta = (
		urlIndex >= 0
			? [...parts.slice(0, urlIndex), ...parts.slice(urlIndex + 1)]
			: parts
	).join(SEPARATOR)

	return { url, meta, text }
}

interface DeviceInfoLineProps {
	text: string
	className?: string
	showIcon?: boolean
}

export function DeviceInfoLine({
	text,
	className,
	showIcon = false,
}: DeviceInfoLineProps) {
	const parsed = parseDeviceInfoText(text)
	if (!parsed) return null

	const { url, meta } = parsed

	return (
		<div
			className={cn(
				"flex min-w-0 max-w-full items-center gap-1.5 text-xs text-tertiary",
				className,
			)}
		>
			{showIcon ? (
				<Monitor className="h-3.5 w-3.5 shrink-0 text-gray-400" />
			) : null}
			{url ? (
				<div className="flex min-w-0 flex-1 items-center gap-1">
					<a
						href={url}
						target="_blank"
						rel="noreferrer noopener"
						title={url}
						className="inline-flex shrink-0 items-center gap-1 underline-offset-2 hover:underline"
					>
						{truncateUrl(url)}
						<ExternalLink className="h-3 w-3" />
					</a>
					{meta ? (
						<span className="min-w-0 truncate" title={meta}>
							{SEPARATOR}
							{meta}
						</span>
					) : null}
				</div>
			) : (
				<span className="truncate">{parsed.text}</span>
			)}
		</div>
	)
}
